var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _text, _line, _text2, _text3, _line2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 420 110",
    width: 420,
    height: 110,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mg",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#2d6a4f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#40916c"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "sunGlow",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#f4a261",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    style: {
      stopColor: "#f4a261",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#f4a261",
      stopOpacity: 0
    }
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 35,
    r: 22,
    fill: "url(#sunGlow)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    from: 80,
    to: 35,
    dur: "3s",
    begin: "0s",
    fill: "freeze",
    calcMode: "spline",
    keySplines: "0.22 0.61 0.36 1",
    keyTimes: "0;1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 0.5,
    dur: "3s",
    begin: "0s",
    fill: "freeze",
    calcMode: "spline",
    keySplines: "0.22 0.61 0.36 1",
    keyTimes: "0;1"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 35,
    r: 12,
    fill: "#f4a261",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    from: 80,
    to: 35,
    dur: "3s",
    begin: "0s",
    fill: "freeze",
    calcMode: "spline",
    keySplines: "0.22 0.61 0.36 1",
    keyTimes: "0;1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 0.9,
    dur: "3s",
    begin: "0s",
    fill: "freeze",
    calcMode: "spline",
    keySplines: "0.22 0.61 0.36 1",
    keyTimes: "0;1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 95 L68 25 L96 95",
    fill: "url(#mg)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57 45 L68 25 L79 45 L75 47 L70 43 L64 47 Z",
    fill: "white",
    opacity: 0.85
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 95 L45 42 L65 75 L40 95",
    fill: "#40916c",
    opacity: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36 55 L45 42 L54 55 L50 57 L47 53 L42 57 Z",
    fill: "white",
    opacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72 95 L95 52 L118 95",
    fill: "#52b788",
    opacity: 0.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 82,
    fontFamily: "'Montserrat', 'Segoe UI', 'Helvetica Neue', Arial, sans-serif",
    fontWeight: 700,
    fontSize: 28,
    fill: "white",
    opacity: 0.9,
    letterSpacing: 5
  }, "HY")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 86,
    x2: 88,
    y2: 86,
    stroke: "#f4a261",
    strokeWidth: 1.5,
    opacity: 0.8
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 138,
    y: 55,
    fontFamily: "'Cinzel', 'Playfair Display', 'Georgia', serif",
    fontWeight: 700,
    fontSize: 30,
    fill: "#1b4332",
    letterSpacing: 3
  }, "HIMACHAL")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 138,
    y: 84,
    fontFamily: "'Cinzel', 'Playfair Display', 'Georgia', serif",
    fontWeight: 400,
    fontSize: 24,
    fill: "#2d6a4f",
    letterSpacing: 8
  }, "YATRA")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 138,
    y1: 92,
    x2: 265,
    y2: 92,
    stroke: "#40916c",
    strokeWidth: 0.8,
    opacity: 0.35
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.04ec37c98c52a3f6f0ca92152af5cf65.svg";
export { ForwardRef as ReactComponent };